import { cva } from '@/styled-system/css';

export const upsellHeaderRecipe = cva({
  base: {
    '[data-c11n-component="Upsell.Root"]:has([data-c11n-component="Upsell.CloseButton"]) &': {
      paddingInlineEnd: '1000',
    },

    '& > [data-c11n-component="Heading"]': {
      color: 'inherit',
      textStyle: 'body-bold',
    },
  },
  variants: {
    tone: {
      neutral: {
        color: 'text.neutral',
      },
      soft: {
        color: 'text.neutral',
      },
      hero: {
        color: 'Upsell.Header.hero.text',
      },
      impact: {
        color: 'text.onImpact.neutral',
      },
    },
  },
});
